import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../assets/css/button/button.module.css';
const Button = ({
    classs,
    text,
    icon,
    alignImg,
    color,
    onClick,
    loading,
    type,
    fontSize,
    spinner
}) => {
    const MYCLASS = {
        btnMain: styles.btnMain,
        btnSecondary: styles.btnSecondary,
        btnOutlineMain: styles.btnOutlineMain,
        btnCircularTransparent: styles.btnCircularTransparent,
        btnOutlineBlack: styles.btnOutlineBlack,
        btnRoundedMain: styles.btnRoundedMain,
        btnRoundedTransparent: styles.btnRoundedTransparent,
        btnRoundedIconMain: styles.btnRoundedIconMain
    };
    const CLASSCOLOR = {
        grayLight: styles.color_gray_light
    };
    const TYPE = {
        submit: 'submit'
    };

    return (
        <>
            <button
                disabled={loading}
                style={{ fontSize }}
                className={`${styles.btn} ${MYCLASS[classs]} ${
                    color ? CLASSCOLOR[color] : ''
                }`}
                type={TYPE[type] || 'button'}
                onClick={onClick}>
                {alignImg === 'left' && <img src={icon} alt="icon" />}

                {text}
                {loading && <img src={spinner} alt="" />}

                {alignImg === 'right' && <img src={icon} alt="icon" />}
            </button>
        </>
    );
};

Button.propTypes = {
    classs: PropTypes.string,
    fontSize: PropTypes.string,
    text: PropTypes.string,
    icon: PropTypes.string,
    spinner: PropTypes.string,
    alignImg: PropTypes.string,
    color: PropTypes.string,
    type: PropTypes.string,
    loading: PropTypes.bool,
    onClick: PropTypes.any
};

export default Button;
